var WooAccount = {
	init:function(){
		$(".btn-register span").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			
			WooAccount.switchToRegister();
		});
		$(".retour span").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			
			
			WooAccount.switchToLogin();
		});
	},
	
	switchToRegister:function(){
		$(".register-container").addClass("visible");
		$(".woocommerce-form-login").addClass("hidden");
		$(".btn-register").addClass("hidden");
	},
	switchToLogin:function(){
		
		$(".register-container").removeClass("visible");
		$(".woocommerce-form-login").removeClass("hidden");
		$(".btn-register").removeClass("hidden");
	}
	
	
}

$(window).load(function(){
	if($(".woocommerce-account").length){
		WooAccount.init();
	}
})